import { useEffect, useState } from "react";

import { db } from "../firebase/config";

const useProfile = (profileID?: string) => {
  const [profile, setProfile] = useState<any>();

  useEffect(() => {
    if (profileID) {
      const fetch = async () => {
        const profileRef = await db.collection("profiles").doc(profileID).get();
        const profileData = profileRef.data();
        setProfile(profileData);
      };

      fetch();
    }
  }, [profileID]);

  return profile;
};

export default useProfile;
